import React, { useState } from 'react'
import { Breadcrumb, Layout } from 'antd'
import { Button } from 'components'
import ModalUpdateUser from './components/ModalUpdateUser'
import { IcEdit, IcTrash } from 'assets/icons'
import UserPageComponent from './components/UserPageComponent'
import { apiDelete, apiGet, apiPost, apiPut } from 'api'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { showErrorMessage } from 'utils'

const initialTableState = {
  totalRows: 0,
  offset: 0,
  limit: 10,
  keywords: '',
  listData: [],
  sort_by: 'id',
  sort_order: null
}

const UserPage = () => {
  const token = useSelector((state) => state.auth.token)
  const [tableState, setTableState] = useState(initialTableState)
  const [modal, setModal] = useState({
    show: false,
    type: 'add',
    data: null
  })
  const columns = [
    {
      name: 'Nama',
      selector: (row) => (row?.fullname ? row?.fullname : row?.company_name),
      sortable: true
    },
    {
      name: 'Nomor Whatsapp',
      selector: (row) => row?.phone_number,
      sortable: true
    },
    {
      name: 'Email',
      selector: (row) => row?.email,
      sortable: true
    },
    {
      name: 'Action',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      width: '100px',
      cell: (row) => (
        <div className="flex items-center justify-center self-center">
          <Button
            className="bg-white border-gray-300 mr-2 hover:bg-gray-50"
            onClick={() => setModal({ show: true, type: 'edit', data: row })}>
            <IcEdit className="text-gray-700" size={16} />
          </Button>
          <Button
            className="bg-white border-[#FDA19B] hover:bg-red-50"
            onClick={() => setModal({ show: true, type: 'delete', data: row })}>
            <IcTrash className="text-primary-500" size={16} />
          </Button>
        </div>
      )
    }
  ]

  const { isLoading, refetch } = useQuery({
    queryKey: [
      'user-list',
      tableState.offset,
      tableState.limit,
      tableState.sort_by,
      tableState.sort_order,
      tableState.keywords
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const params = {
        keywords: tableState.keywords,
        offset: tableState.offset,
        limit: tableState.limit,
        sort_by: tableState.sort_by,
        sort_order: tableState.sort_order,
        role_type: 'cust'
      }
      const res = await apiGet({ url: 'user-service/admin/users', token, data: params })
      return res
    },
    onSuccess: (res) => {
      setTableState({
        ...tableState,
        listData: res?.resData?.data,
        totalRows: res?.resData?.meta?.total
      })
    }
  })

  const saveData = async (data) => {
    try {
      let res
      let body = {
        ...data
      }

      if (data?.id) {
        const id = data?.id
        res = await apiPut({ url: `user-service/admin/users/${id}`, token, data: body })
      } else {
        res = await apiPost({ url: `user-service/admin/users/cust`, token, data: body })
      }
      if (res?.resStatus === 200 || res?.resStatus === 201) {
        setModal({
          ...modal,
          show: false
        })
        refetch()
      } else {
        showErrorMessage({ content: res?.resData?.errors?.[0]?.message })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const deleteData = async (data) => {
    try {
      let res
      res = await apiDelete({ url: `user-service/admin/users/${data?.id}`, token })
      if (res?.resStatus === 200 || res?.resStatus === 201) {
        setModal({
          ...modal,
          show: false
        })
        refetch()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Layout style={{ padding: '0 24px 24px', background: '#F5F5F5' }}>
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Master Data</Breadcrumb.Item>
        <Breadcrumb.Item>User</Breadcrumb.Item>
      </Breadcrumb>
      <ModalUpdateUser
        isOpen={modal.show}
        type={modal.type}
        user={modal.data}
        onSubmit={saveData}
        onDelete={deleteData}
        onCancel={() => setModal({ ...modal, show: false })}
      />
      <UserPageComponent
        isLoading={isLoading}
        columns={columns}
        data={tableState?.listData}
        onAdd={() => setModal({ show: true, type: 'add', data: {} })}
        tableState={tableState}
        setTableState={setTableState}
      />
    </Layout>
  )
}
export default UserPage
